import axios from "axios";

// Audit requests are silent: do not use the shared loading/message interceptors.
const client = axios.create({ timeout: 10000 });

// No password, hash, or caller-supplied user identity is sent to the server.
export const recordScreenLock = () => client.post("/api/sysConfig/SystemOperationLog/RecordScreenLock", null, {
	headers: { Authorization: `Bearer ${localStorage.getItem("logintoken")}` }
});
